module.exports = __webpack_public_path__ + "img/violet_131.a96e0b20.png";